"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialUpdateResponseT = exports.SerialUpdateResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SerialUpdateResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSerialUpdateResponse(bb, obj) {
        return (obj || new SerialUpdateResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSerialUpdateResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SerialUpdateResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    log(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    closed() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startSerialUpdateResponse(builder) {
        builder.startObject(2);
    }
    static addLog(builder, logOffset) {
        builder.addFieldOffset(0, logOffset, 0);
    }
    static addClosed(builder, closed) {
        builder.addFieldInt8(1, +closed, +false);
    }
    static endSerialUpdateResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSerialUpdateResponse(builder, logOffset, closed) {
        SerialUpdateResponse.startSerialUpdateResponse(builder);
        SerialUpdateResponse.addLog(builder, logOffset);
        SerialUpdateResponse.addClosed(builder, closed);
        return SerialUpdateResponse.endSerialUpdateResponse(builder);
    }
    unpack() {
        return new SerialUpdateResponseT(this.log(), this.closed());
    }
    unpackTo(_o) {
        _o.log = this.log();
        _o.closed = this.closed();
    }
}
exports.SerialUpdateResponse = SerialUpdateResponse;
class SerialUpdateResponseT {
    constructor(log = null, closed = false) {
        this.log = log;
        this.closed = closed;
    }
    pack(builder) {
        const log = (this.log !== null ? builder.createString(this.log) : 0);
        return SerialUpdateResponse.createSerialUpdateResponse(builder, log, this.closed);
    }
}
exports.SerialUpdateResponseT = SerialUpdateResponseT;
